// Independent page composition for Privacy & Security Services.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function PrivacySecurityPage({ service }) {
  return h(PageFrame, { service, tone: 'editorial', hero: diagram(service, 'boundary') },
    section('Protection starts with clear responsibilities', context(service), { className: 'ai-narrow-section' }),
    section('From exposure to action', deliverables(service, 'columns'), { theme: 'ai-wash' }),
    section(null, split(answer(service), scenario(service))),
    section(null, scope(), { className: 'ai-narrow-section' })
  );
};
